import React from "react";
import { Select as MuiSelect, MenuItem } from "@material-ui/core";
import { useField } from "formik";

// Helper functions for wrapper styles
const getDefaultWrapperStyle = (background, color) => ({
  backgroundColor: background ? background : "rgba(0, 0, 0, 0.04)",
  padding: "8px 15px 0px",
  marginBottom: "10px",
  borderBottom: `1px solid ${color}`,
  borderRadius: "4px 4px 0 0",
  boxSizing: "border-box",
});

const getNakedWrapperStyle = () => ({
  backgroundColor: "none",
  padding: "8px 15px 0px",
  marginBottom: "10px",
  borderRadius: "4px 4px 0 0",
  boxSizing: "border-box",
});

export default function Select({
  label,
  options = [],
  multiple,
  tip,
  defaultValue = "",
  variant,
  color = "#255915",
  background,
  ...other
}) {
  // Determine which wrapper style to use based on the variant
  const wrapperStyle =
    variant === "naked"
      ? getNakedWrapperStyle()
      : getDefaultWrapperStyle(background, color);

  // const focusWithinStyle = {
  //   background: "rgba(0, 0, 0, 0.05)",
  // };

  // Styles for elements
  const wrapperLabelStyle = {
    display: "block",
    marginBottom: 0,
  };

  const labelStyle = {
    fontSize: "12px",
    color: color,
    letterSpacing: "0.4px",
  };

  const selectStyle = {
    borderColor: "#f3f6f9",
    color: "#464e5f",
    transition:
      "color 0.15s ease, background-color 0.15s ease, border-color 0.15s ease, box-shadow 0.15s ease",
    width: "100%",
  };

  return (
    <>
      <style>
        {`
          .select-view:focus-within {
            background: rgba(0, 0, 0, 0.05);
          }

          .select .MuiSelect-select:focus {
            background-color: rgba(0, 0, 0, 0);
          }

          .select .MuiSelect-icon {
            color: ${color} !important;
          }
        `}
      </style>
      <div style={wrapperStyle} className="select-view">
        <label style={wrapperLabelStyle}>
          {label && <div style={labelStyle}>{label}</div>}
          <MuiSelect
            style={selectStyle}
            className="select"
            disableUnderline={true}
            multiple={multiple}
            defaultValue={defaultValue}
            inputProps={{ "data-testid": "select" }}
            {...other}
          >
            {options.map(({ value, label }) => (
              <MenuItem key={value} value={value}>
                {label}
              </MenuItem>
            ))}
          </MuiSelect>
        </label>
      </div>
      {tip && <div>{tip}</div>}
    </>
  );
}

export function MappedSelect(props) {
  const errorStyle = { color: "red" };
  const formGroupStyle = { marginBottom: "1.75rem" };

  function getTip(meta = {}, tip) {
    if (meta.touched && meta.error && typeof meta.error !== "object") {
      return <span style={errorStyle}>{meta.error}</span>;
    }
    if (tip) {
      return <span style={{ color: "rgba(0, 0, 0, 0.6)" }}>{tip}</span>;
    }
  }

  const [field, meta] = useField(props.name);
  return (
    <div style={formGroupStyle}>
      <Select {...field} {...props} tip={getTip(meta, props.tip)} />
    </div>
  );
}
